import React from 'react';
import { CircledLetter, CustomTextWithLabel, LuggageTagPage, WheelchairContent } from './luggageTagsCommon';
import {Text, View} from '@react-pdf/renderer';
import { getDarkBrandColor, getPrimaryBrandColor } from "../../utils/themePdfUtils";
import CFC_Logo from "./CFC_Logo";

const CFCLuggageTagPage = props => {
    return (
        <LuggageTagPage
            {...props}
            tagLabel={props.tagLabel}
            isWheelchair={props.isWheelchair}
            mainContentTop={
                <CfcInfoPart
                    passenger={props.passenger}
                    rotate={true}
                    stepLetter="E"
                    type={props.type}
                />
            }
            mainContentBottom={
                <CfcInfoPart
                    passenger={props.passenger}
                    stepLetter="B"
                    type={props.type}
                />
            }
        />
    )
}

export default CFCLuggageTagPage;

const CfcInfoPart = props => {
    const containerStyle = {
        flex: 1,
        display: "flex",
        paddingBottom: "10px",
    }
    if(props.rotate) {
        containerStyle.transform = "rotate(180deg)";
    }

    const guestName = `${props.passenger.title} ${props.passenger.firstName} ${props.passenger.lastName}`;
    const deckNr = props.passenger.deckNumber;
    const cabinNr = props.passenger.cabinNumber;
    const telephoneNr = props.passenger.mobileNumber || "/";
    const disembarkationText = props.passenger.disembarkationText || "/";

    const isDisembark = props.type === "disembarkation";
    const isWheelchair = props.type === "wheelchair";

    const isPriority = props.passenger.priorityEmbarkation;
    let frameColor = getPrimaryBrandColor();
    let stapleColor = "white";

    switch (props.type) {
        case "embarkation":
            if(isPriority) {
                frameColor = "#F1ECE7";
                stapleColor = getDarkBrandColor();
            }
            break;
        case "disembarkation":
            frameColor = "#F68C4E"
            break;
        case "wheelchair":
            frameColor = "#d2c1b1"; // maybe switch to D0BFB0
            stapleColor = getDarkBrandColor();
            break;
    }

    return (
        <View style={containerStyle}>
            <View style={{padding: "12px", flex: 1, display: "flex"}}>
                <View style={{width: "100%", marginBottom: "6px", display: "flex", justifyContent: "center", flexDirection: "row", alignItems: "center"}}>
                    <CFC_Logo />
                </View>
                <View style={{backgroundColor: frameColor, padding: "8px 6px 0px 6px", flex: 1}}>
                    {isWheelchair &&
                        <WheelchairContent rotate={props.rotate} text="Fauteuil roulant" />
                    }
                    {!isWheelchair &&
                    <>
                        <CustomTextWithLabel label="Nom du navire" value="Renaissance" flex={1} maxFontSize="14px"/>
                        {isDisembark &&
                                <CustomTextWithLabel value={disembarkationText} flex={1} style={{fontWeight: "bold", textTransform: "uppercase"}} maxFontSize="14px"/>
                        }
                        {!isDisembark && isPriority &&
                            <CustomTextWithLabel value="Priority" flex={1} style={{fontWeight: "bold", textTransform: "uppercase", color: "red", fontSize: "20px"}} maxFontSize="14px"/>
                        }
                            <CustomTextWithLabel label="Cabine" value={cabinNr} flex={1} maxFontSize="14px"/>
                            <CustomTextWithLabel label="Pont/Position" value={deckNr} flex={1} maxFontSize="14px"/>
                            <CustomTextWithLabel label="Nom du passager" value={guestName} flex={2} maxFontSize="14px"/>
                            <CustomTextWithLabel label="Téléphone" value={telephoneNr} flex={1} maxFontSize="14px"/>
                    </>
                    }

                </View>
            </View>
            <View style={{paddingTop: "6px", backgroundColor: frameColor, textAlign: "center"}}>
                <Text style={{ textTransform: "uppercase", color: stapleColor, fontSize: "9px"}}>
                    Agrafez ou collez ici
                </Text>
                <CircledLetter letter={props.stepLetter} color={stapleColor} reduceBottomMargin={true}/>
            </View>
        </View>
    )
}